module.exports = __webpack_public_path__ + "src/img/artist/work04_1.jpg?49ad64fe739ff4febee27cd1d0713848";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work04_1.jpg
// module id = 21
// module chunks = 0